// extracted by mini-css-extract-plugin
export default {"tags":"style_tags__P7Gpw","content":"style_content__CVox1"};